module.exports = __webpack_public_path__ + "media/team/Aren-ea5a3bac.png";